import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";
import QuoteItems from "./QuoteItems";
import {
  QuoteServiceInfo,
  GridRow,
  HeaderWrapperTable,
  Title,
  EnquiryIdHyphen,
  GridSubLabel,
  QuoteInfoAndConditionsInfo,
  ServiceInfo,
} from "./QuoteView.styled";
import "./QuoteView.scss";

const QuoteServices = (props) => {
  const {
    t,
    quoteData,
    siteId,
    setQuoteData,
    isOperationType,
    setIsRefreshQuoteData,
    isStudyTeamType,
    setIsRefeshSiteData,
  } = props;

  return (
    <QuoteServiceInfo>
      {quoteData?.services?.length > 0 &&
        quoteData?.services.map((service, serviceIndex) => {
          return (
            <React.Fragment key={"quoteEnquiryService" + serviceIndex}>
              <QuoteInfoAndConditionsInfo
                marginBottom="20px"
                padding="0px"
                boxShadow="0px 0px 0px 0px rgba(0,76,127,0.25)"
              >
                <GridRow marginBottom="0px" marginTop="0px">
                  <HeaderWrapperTable>
                    <GridRow
                      column="auto 1fr"
                      marginBottom="0px"
                      marginTop="0px"
                      gridGap=".5rem"
                    >
                      <Title marginTop="6px" fontWeight="700">
                        <Anchor
                          url={`/site/view/${siteId}/enquiry-view-${service.sellingPrice.requestId}`}
                          target="_blank"
                          className="kickoff-quote-view__link-underline "
                        >
                          {t("ENQUIRY") +
                            " #" +
                            service?.sellingPrice?.requestId}
                        </Anchor>
                        <EnquiryIdHyphen decoration="none"> - </EnquiryIdHyphen>
                      </Title>
                      <GridSubLabel fontSize="20px" color="#fff">
                        {service?.label}
                      </GridSubLabel>
                    </GridRow>
                  </HeaderWrapperTable>
                </GridRow>

                <QuoteItems
                  enquiryId={service.sellingPrice.requestId}
                  sellingPriceId={service?.sellingPrice?.id}
                  itemList={service.items}
                  currency={service.sellingPrice?.currency}
                  quoteId={quoteData.id}
                  siteId={siteId}
                  setQuoteData={setQuoteData}
                  isSiteCommentEdit={quoteData.isSiteCommentEdit}
                  koStatus={quoteData.koStatus}
                  isOperationType={isOperationType}
                  setIsRefreshQuoteData={setIsRefreshQuoteData}
                  isStudyTeamType={isStudyTeamType}
                  setIsRefeshSiteData={setIsRefeshSiteData}
                />
              </QuoteInfoAndConditionsInfo>
            </React.Fragment>
          );
        })}
      {quoteData?.services?.length === 0 && (
        <ServiceInfo color="#767676">{t("QUOTE_NO_SERVICES")}</ServiceInfo>
      )}
    </QuoteServiceInfo>
  );
};

QuoteServices.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(QuoteServices);
